import React from "react";
import { Box } from '@curves/ui-base';
import MeasurePieBodyCompositionDistributionChart from "@Local/Dashboard/MeasurePieBodyCompositionDistributionChart";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const BodyCompositionDistributionSection = ({ sourceData, onTrendAreaClick }) => {
	return (
		<Box className="measurement-group-content">
			<Box className="measurement-group-content-Chart">
				<Box className="measurement-group-content-Chart_button" onClick={() => onTrendAreaClick(sourceData?.bodyCompositionDistributionTrendType)}>
					<ChevronRightIcon />
				</Box>
				<MeasurePieBodyCompositionDistributionChart
					className="measurement-group-content-Chart"
					weight={sourceData?.weight}
					sourceData={sourceData?.pieBodyCompositionDistribution}
				/>
			</Box>
		</Box>
	);
};

export default BodyCompositionDistributionSection;
